import { motion } from "framer-motion";
import { Eyebrow, Reveal, ease } from "./utils";

const steps = [
  {
    n: "01",
    title: "Book a Free Revenue Opportunity Call",
    copy: "In a focused 20–30 minute conversation, we learn how your business currently generates leads, handles follow-up, serves customers, and where growth may be getting blocked.",
  },
  {
    n: "02",
    title: "Complete Your Revenue Opportunity Assessment",
    copy: "Qualified businesses receive access to the Apex Flow Assessment Portal to share their goals, revenue data, lead flow, customer base, capacity, and current systems.",
  },
  {
    n: "03",
    title: "Receive a Human-Reviewed Recommendation",
    copy: "Apex Flow reviews the assessment, identifies the highest-value opportunities, and manually approves the recommended next step.",
  },
  {
    n: "04",
    title: "Build a More Predictable Growth System",
    copy: "Once enrolled, Apex Flow helps install the right systems, campaigns, follow-up, visibility, reporting, and strategic support.",
  },
];

export default function HowItWorks() {
  return (
    <section data-testid="how-it-works-section" id="how-it-works" className="relative overflow-hidden bg-brand-gray-light py-24 md:py-32">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>A Simple, Human-Reviewed Process</Eyebrow></Reveal>
          <Reveal delay={1}>
            <h2 className="mt-6 font-serif text-4xl md:text-5xl tracking-tight text-brand-black leading-[1.08]">
              Start With Clarity. Then Build <span className="gold-text">What Matters.</span>
            </h2>
          </Reveal>
        </div>

        <div className="relative mt-16 pl-2">
          {/* vertical line */}
          <div className="absolute left-[27px] top-2 bottom-2 w-px bg-brand-gray-soft" />
          <motion.div
            className="absolute left-[27px] top-2 w-px bg-gradient-to-b from-brand-gold to-brand-gold-deep origin-top"
            style={{ bottom: 8 }}
            initial={{ scaleY: 0 }}
            whileInView={{ scaleY: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.6, ease }}
          />

          <div className="space-y-8">
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={i} className="relative pl-20">
                <div className="absolute left-0 top-0 flex h-14 w-14 items-center justify-center rounded-full bg-white border border-brand-gray-soft shadow-luxe">
                  <span className="font-mono text-sm font-semibold text-brand-gold">{s.n}</span>
                </div>
                <div className="rounded-2xl bg-white border border-brand-gray-soft p-7 shadow-[0_10px_30px_rgba(17,17,17,0.04)] transition-all duration-300 hover:-translate-y-1 hover:border-brand-gold/40 hover:shadow-luxe">
                  <h3 className="font-sans text-xl font-semibold tracking-tight text-brand-black">{s.title}</h3>
                  <p className="mt-3 font-sans text-[15px] leading-relaxed text-brand-black/65">{s.copy}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
